'use client'

import JsCookie from 'js-cookie'

// Types
import type { CookieAttributes } from '@/types/helpers/cookies'

// Get a cookie value
const get = (name: string): string | undefined => JsCookie.get(name)

// Set a cookie value
const set = (name: string, value: string, options?: CookieAttributes): string | undefined => JsCookie.set(name, value, options)

// Remove a cookie value
const remove = (name: string, options?: CookieAttributes): void => JsCookie.remove(name, options)

// Export a Cookies object with the same API as js-cookie
const Cookies = { get, set, remove }

export default Cookies
